import { Col, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import { addProductToCartStore } from '~/store/actions/CartProductAction';
import { getNumberWithCommas } from '~/utils';
import CancelModal from '../FormCancel';
import styles from './ItemProduct.module.scss';

const cx = classNames.bind(styles);

const ItemProduct = ({ data }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);
    const onAgreeLogin = () => {
        navigate(config.routes.login);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    const handleNavigateDetailService = () => {
        navigate(`/thong-tin-san-pham/${data.id}`);
    };

    const handleAddProductToCart = async () => {
        data.amount = 1;
        data.total_price = data.deducted_price * data.amount;
        data.sharer_id = data.sharer_id || '';
        await dispatch(addProductToCartStore(data));
        notification.open({
            message: 'Product added to cart',
            duration: 2,
            placement: 'top',
        });

        // if (isLogin) {
        //     data.amount = 1;
        //     data.total_price = data.deducted_price * data.amount;
        //     data.sharer_id = data.sharer_id || '';
        //     await dispatch(addProductToCartStore(data));
        //     notification.open({
        // message: 'Product added to cart',
        //         duration: 2,
        //         placement: 'top',
        //     });
        // } else {
        //     localStorage.setItem('navigateAfterLogin', config.routes.products);
        //     setIsShowRequireLogin(true);
        // }
    };
    const handleOrderNow = () => {
        data.amount = 1;
        data.total_price = data.deducted_price * data.amount;
        localStorage.setItem('listProductOrder', JSON.stringify([data]));
        localStorage.setItem('totalPriceProductOrder', data.total_price);
        if (isLogin) {
            navigate(config.routes.checkOut);
        } else {
            localStorage.setItem('navigateAfterLogin', config.routes.checkOut);
            setIsShowRequireLogin(true);
        }
    };

    return (
        <>
            <div className={cx('product_item_desktop')}>
                <Row justify="center">
                    <div className={cx('product_image')}>
                        <img
                            src={data?.thumbnail || IMAGES.ImagePlaceholder}
                            alt=""
                            style={{ objectFit: data?.thumbnail ? 'cover' : 'contain' }}
                        />
                        <div className={cx('card_amount_sale')}>
                            <span>{data?.amount_sale} sold</span>
                        </div>
                        <div className={cx('overlay')} onClick={handleNavigateDetailService}></div>
                        {data?.inventory_amount_branch > 0 ? (
                            <div className={cx('events')}>
                                <div className={cx('addCart_btn')} onClick={handleAddProductToCart}>
                                    <img src={SVGS.ImageAddCard} alt="" />
                                </div>
                                <div className={cx('buy_btn')} onClick={handleOrderNow}>
                                    Buy now
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className={cx('no_product')} onClick={handleNavigateDetailService}>
                                    <div className={cx('btn_text')}>Sold out</div>
                                </div>
                            </>
                        )}

                        {parseInt(data?.sale_price) ? (
                            <Row>
                                <span className={cx('sale_off')}>
                                    -&nbsp;{Math.round((data?.sale_price * 100) / data?.price)}%
                                </span>
                            </Row>
                        ) : null}
                    </div>
                </Row>

                <div className={cx('product_container')} onClick={handleNavigateDetailService}>
                    {/* {parseInt(data?.sale_price) ? (
                        <>
                            <Row justify="end">
                                <span className={cx('sale_off')}>
                                    Sale {Math.round((data?.sale_price * 100) / data?.price)}%
                                </span>
                            </Row>
                        </>
                    ) : null} */}
                    <Row className={cx('name_category')}>{data?.category?.title}</Row>
                    <Row className={cx('name_product')}>{data?.title}</Row>
                    <Row className={cx('amount_sale')}>
                        <Col xs={6}>
                            <Row>Sold:</Row>
                        </Col>
                        <Col xs={18}>
                            <Row justify="end" align="middle">
                                {data?.amount_sale} product
                            </Row>
                        </Col>
                    </Row>
                    <Row justify="center" className={cx('price')}>
                        <Col xs={0} sm={4} className={cx('price_text')}>
                            <Row>Price:</Row>
                        </Col>
                        <Col xs={24} sm={20} justify="center">
                            <Row align="middle" className={cx('price_number')}>
                                {parseInt(data?.sale_price) ? (
                                    <>
                                        <span className={cx('price_origin')}>{getNumberWithCommas(data?.price)} d</span>
                                    </>
                                ) : null}
                                <span className={cx('price_sale')}>
                                    {getNumberWithCommas(data?.price - data?.sale_price)} d
                                </span>
                            </Row>
                        </Col>
                    </Row>
                </div>
                {isShowRequireLogin && (
                    <Modal
                        centered
                        visible={isShowRequireLogin}
                        onCancel={() => setIsShowRequireLogin(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={500}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <CancelModal
                                onAgreeCancel={onAgreeLogin}
                                onRejectCancel={onRejectLogin}
                                text="Do you want to log in to continue?"
                            />
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
};

export default ItemProduct;
